import * as tslib_1 from "tslib";
import { AbstractSearchCriteria } from './abstract-search-criteria';
var ProductDetailsSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(ProductDetailsSearchCriteria, _super);
    function ProductDetailsSearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productCode = '';
        _this.serviceType = '';
        return _this;
    }
    return ProductDetailsSearchCriteria;
}(AbstractSearchCriteria));
export { ProductDetailsSearchCriteria };
